import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text, Button } from '@bigcommerce/big-design';

import { updateShipments } from '../../redux/actions/purchaseOrders';
import { assignmentCreate } from '../../redux/actions/assignments';

const AddSupplierAssignmentModal = ({ payload, 
  supplier, 
  modalProductId,
  modalVariantId,
  modalOptions,
  modalProductName,
  modalType, 
  showAddSupplierAssignmentModal, 
  setShowAddSupplierAssignmentModal,
  createAssignment,
  settings
}) => {

  const [supplierSku, setSupplierSku] = useState(null);
  const [supplierPrice, setSupplierPrice] = useState(null);
  const [minimumQuantity, setMinimumQuantity] = useState(null);
  const [orderMultiple, setOrderMultiple] = useState(null);
  const [packQuantity, setPackQuantity] = useState(null);

  const changeSku = (event) => {
    let value = event.target.value;
    setSupplierSku(value);
  }

  const changePrice = (event) => {
    let value = event.target.value.replace(/[^\d.-]+/g, '');;
    setSupplierPrice(value);
  }

  const changeOrderMultiple = (event) => {
    let value = parseInt(event.target.value);
    setOrderMultiple(value);
  }

  const changePackQuantity = (event) => {
    let value = parseInt(event.target.value);
    setPackQuantity(value);
  }

  const changeMinimum = (event) => {
    let value = parseInt(event.target.value);
    setMinimumQuantity(value);
  }

  const update = () => {
    let assignmentValues = {
      productId: modalProductId,
      variantId: modalVariantId,
      type: modalType,
      supplierSku: supplierSku,
      supplierPrice: supplierPrice,
      minimumQuantity: (minimumQuantity || 0).toString()
    }

    if(settings?.settings?.order_multiples) {
      assignmentValues.orderMultiple = (orderMultiple || 1).toString();
    }

    if(settings?.settings?.pack_quantities) {
      assignmentValues.packQuantity = (packQuantity || 1).toString();
    }

    console.log(assignmentValues);

    createAssignment(payload, supplier.id, assignmentValues);
    setShowAddSupplierAssignmentModal(false);
  }

  return (
    <>
      <Modal
        actions={[
          {
            text: 'Cancel',
            variant: 'subtle',
            onClick: () => setShowAddSupplierAssignmentModal(false),
          },
          { text: 'Add Assignment', onClick: () => update() },
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        header="Add Assignment"
        isOpen={showAddSupplierAssignmentModal}
        onClose={() => setShowAddSupplierAssignmentModal(false)}
      >
        <H3><strong>Supplier</strong>: { supplier.supplier_name }</H3>
        <H3><strong>Product</strong>: {modalProductName}</H3>

        { modalOptions && modalOptions.map(option =>
            <li>
              <strong>{ option.option_display_name || option.display_name }</strong>: { option.label || option.display_value }
            </li>
          )
        }

        <Input
          label="Supplier SKU"
          onChange={changeSku}
          placeholder="Supplier SKU"
          type="text"
          value={supplierSku}
          required
        />
        
        <Input
          label="Supplier Price"
          onChange={changePrice}
          placeholder="Supplier Price"
          type="number"
          value={supplierPrice}
          required
        />

        <Input
          label="Minimum Quantity"
          onChange={changeMinimum}
          placeholder="Minimum Quantity"
          type="number"
          value={minimumQuantity}
          required
        />

        { settings?.settings?.order_multiples &&
          <Input
            label="Order Multiple"
            onChange={changeOrderMultiple}
            placeholder="Order Multiple"
            type="number"
            value={orderMultiple}
            required
          />
        }

        { settings?.settings?.pack_quantities &&
          <Input
            label="Pack Quantity"
            onChange={changePackQuantity}
            placeholder="Pack Quantity"
            type="number"
            value={packQuantity}
            required
          />
        }

      </Modal>
    </>
  )

}

const mapStateToProps = state => ({
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  createAssignment: (payload, supplierId, assignmentValues) => dispatch(assignmentCreate(payload, supplierId, assignmentValues)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddSupplierAssignmentModal);
